import { render, staticRenderFns } from "./StclN_Details2.vue?vue&type=template&id=630f0e7c"
import script from "./StclN_Details2.vue?vue&type=script&lang=js"
export * from "./StclN_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports